import { Avatar, Button, FormHelperText } from '@mui/material';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import DialogArtistName from 'commons/DialogArtistName';
import FormInput from 'commons/Form/FormInput';
import FormCheckBoxController from 'commons/FormHook/FormCheckBoxController';
import FormInputWithIcons from 'commons/FormInputWithIcons';
import Text from 'commons/Text';
import { STATUS_REQUEST_KEY } from 'configs/Constant';
import useDebounce from 'hooks/useDebounce';

import AutocompleteSearchUserWrapper from './components/AutocompleteSearchUserWrapper';
import DialogCancelTagRequest from './components/DialogCancelTagRequest';
import useStyles from './styles';

const FormUserByRoleCollector = ({
  artworkFormState,
  hasCertificate,
  userFilter,
  handleInputSearchUser,
  handleCheckArtist,
  handleClickPaper,
  handleSelectUser,
  handleSearchAgain,
  handleClickCancelRequest,
  handleClickClearIon,
  handleClickSelectSaveUser,
  dialogCancelTagRequest,
  dialogArtistName,
  isShowCustomPaper,
  titleListUser,
  titleSaveUser,
  roleUser,
  showText = true,
  isShowCancelRequest = true,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { formState, control, watch, register } = artworkFormState;
  const {
    isShowInputArtistName,
    isShowCheckBoxCustom,
    checkedArtistUnknown,
    selectedUser,
    artistName,
    artistTagRequest,
    isShowRejectTagRequest,
  } = watch();

  const { request_to, status: statusTagRequest } = artistTagRequest || {};
  const [inputValue, setInputValue] = useState('');
  const debounceInputValue = useDebounce(inputValue);

  return (
    <>
      {selectedUser?.id && !isShowRejectTagRequest && (
        <div>
          <FormInputWithIcons
            selectedUser={selectedUser}
            statusTagRequest={statusTagRequest}
            onClickClearIon={handleClickClearIon}
          />
          {isShowCancelRequest &&
            statusTagRequest === STATUS_REQUEST_KEY.REQUEST_RECEIVED &&
            selectedUser?.id === request_to?.id &&
            !hasCertificate && (
              <Button
                variant="outlined"
                className={classes.btn}
                onClick={handleClickCancelRequest}
              >
                <Text type="sm">{t('cancel_request')}</Text>
              </Button>
            )}
        </div>
      )}

      {isShowRejectTagRequest && (
        <div>
          <div className={classes.wrapItemUser}>
            <Avatar
              src={selectedUser?.avatar}
              className={classes.imageUser}
            />
            <Text type="sm">{`${selectedUser?.legal_name || ''} ${
              selectedUser?.name ? `[${selectedUser.name}]` : ''
            }`}</Text>
          </div>
          <FormHelperText error>{t('the_artist_has_rejected_tagged_request')}</FormHelperText>
        </div>
      )}

      {!isShowInputArtistName && !selectedUser?.id && (
        <AutocompleteSearchUserWrapper
          userFilter={userFilter}
          handleInputSearchUser={(e) => {
            handleInputSearchUser?.(e);
            setInputValue(e.target.value);
          }}
          handleClickPaper={handleClickPaper}
          handleSelectUser={handleSelectUser}
          handleClickSelectSaveUser={handleClickSelectSaveUser}
          selectedUser={selectedUser}
          checkedArtistUnknown={checkedArtistUnknown || hasCertificate}
          formState={formState}
          isShowCustomPaper={isShowCustomPaper}
          titleListUser={titleListUser}
          titleSaveUser={titleSaveUser}
          roleUser={roleUser}
          inputValue={debounceInputValue}
        />
      )}

      {isShowInputArtistName && !selectedUser?.id && (
        <div>
          <FormInput
            {...register('artistName')}
            disabled
            labelStyle={classes.formInputLabel}
            textFieldStyle={classes.textFieldStyle}
            wrapFormInputStyle={classes.wrapFormInput}
          />
        </div>
      )}

      {statusTagRequest === STATUS_REQUEST_KEY.REQUEST_APPROVED && (
        <Text
          type="xs"
          mt={8}
        >
          {t('the_artist_has_approved_tagged_request')}
        </Text>
      )}

      {(selectedUser?.id || artistName) &&
        statusTagRequest !== STATUS_REQUEST_KEY.REQUEST_APPROVED &&
        !hasCertificate &&
        showText && (
          <Text
            type="sm"
            mt={8}
            onClick={handleSearchAgain}
            className={classes.textSearchAgain}
          >
            <Trans
              i18nKey="want_to_change_name_search_again"
              values={{ search: t('search_again') }}
            />
          </Text>
        )}

      {isShowCheckBoxCustom && (
        <FormCheckBoxController
          name="checkedArtistUnknown"
          control={control}
          onChange={handleCheckArtist}
          error={!!formState?.errors.checked}
          helperText={formState?.errors.checked?.message}
          textCheckBox={t('the_artist_is_unknown')}
          disabled={hasCertificate}
        />
      )}

      <DialogArtistName {...dialogArtistName} />
      <DialogCancelTagRequest {...dialogCancelTagRequest} />
    </>
  );
};

export default FormUserByRoleCollector;
